import React, { useContext } from "react";
import { useMsal } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { userAuthMicrosoft } from "../../../../services/apis";
import { SignInContext } from "../../../../scenes/sign-in";
import { track } from "src/main_app/mixpanel";

const SignInMicrosoft = (props) => {
  const signInContext = useContext(SignInContext);

  const handleLogin = async () => {
    const msalInstance = new PublicClientApplication({
      auth: {
        clientId: props.loginConfig.clientId,
        authority: props.loginConfig.authorityUrl,
        knownAuthorities: ["login.microsoftonline.com"],
        redirectUri: window.location.protocol + "//" + window.location.host,
      },
    });

    signInContext.setLoading(true);

    let authInfo;

    try {
      authInfo = await msalInstance.loginPopup({
        scopes: ["User.Read"],
      });
    } catch (e) {
      // No toast for a closed or blocked popup, so it is tracked here rather
      // than through setAfterLogin.
      track("Login failed", {
        source: "web",
        method: "microsoft",
        reason: e?.errorCode || "microsoft_popup_failed",
      });
      signInContext.setLoading(false);
      return;
    }

    userAuthMicrosoft(authInfo.accessToken, props.tenantConfig.slug)
      .then((r) => {
        signInContext.setAfterLogin({
          status: "ok",
          data: r.data,
          method: "microsoft",
        });
      })
      .catch((e) => {
        signInContext.setAfterLogin({
          status: "failed",
          message: e.response?.data?.error?.message,
          method: "microsoft",
          reason: e.response ? "microsoft_rejected" : "network_error",
          httpStatus: e.response?.status,
          email: authInfo.account?.username,
        });
      })
      .finally(() => signInContext.setLoading(false));
  };

  return (
    <button
      className="btn btn-default"
      onClick={() => handleLogin()}
      style={{ width: "100%", position: "relative" }}
    >
      <svg
        fill="#333333"
        data-icon="login-microsoft"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        color="#333333"
        role="img"
        style={{ position: "absolute", left: "2rem" }}
      >
        login-microsoft<path d="M7.6 0H0V7.6H7.6V0Z" fill="#F25022"></path>
        <path d="M16 0H8.40002V7.6H16V0Z" fill="#7FBA00"></path>
        <path d="M7.6 8.40002H0V16H7.6V8.40002Z" fill="#00A4EF"></path>
        <path d="M16 8.40002H8.40002V16H16V8.40002Z" fill="#FFB900"></path>
      </svg>
      CONTINUE WITH MICROSOFT
    </button>
  );
};

export default SignInMicrosoft;
